/// Resolve a dataset's stored palette short-name (a `cat-*` key without the
/// prefix, e.g. "sky") to a theme-correct color. Reads the generated
/// `--token-color-cat-*` CSS var so the value tracks light/dark and matches the
/// categorical palette used everywhere else. Falls back to `cat-default` for an
/// empty or unknown token.
export function resolveDatasetColor(token: string | null | undefined): string {
  const style = getComputedStyle(document.documentElement);
  const key = token && token.length > 0 ? `cat-${token}` : "cat-default";
  const resolved = style.getPropertyValue(`--token-color-${key}`).trim();
  return resolved || style.getPropertyValue("--token-color-cat-default").trim();
}

/// `resolveDatasetColor` as a CSS value: no style read, and it follows a theme
/// switch. A name that is not a palette key falls back to the default.
export function datasetColorVar(token: string | null | undefined): string {
  const key = token && /^[a-z0-9-]+$/.test(token) ? token : "default";
  return `var(--token-color-cat-${key}, var(--token-color-cat-default))`;
}
